import React from 'react';
import { graphql } from "gatsby";

import Layout from '../../components/layout.js';
import SEO from '../../components/seo.js';
import PageHeading from '../../components/page-heading.js';
import CaseStudyTile from '../../components/case-study-tile.js';
import articles, { withImages } from '../../data/articles.js';
import '../../styles/article.scss';

const CaseStudies = ({data}) => {

    const items = withImages(articles.filter(article => article.type === 'Case Study'), data);

    return (
        <Layout background="stone">
            <SEO title="54 Bit Studios Case Studies" />
            <PageHeading h1="Case Studies" h2="" blurb="See how we've helped Shopify and Shopify Plus brands grow, from custom redesigns to speed, SEO and conversion improvements." />
            <section className='ff case-studies blog' id='case-studies'>
                <div className="grid">
                    {items.map(article => (
                        <CaseStudyTile
                            key={article.client}
                            image={article.image}
                            client={article.client}
                            blurb={article.blurb}
                            tags={article.tags}
                            link={article.link}
                            type={article.type}
                            year={article.year}
                        />
                    ))}
                </div>
            </section>
        </Layout>
    );
};

export default CaseStudies;

export const query = graphql`
    query {
        allFile(filter: { sourceInstanceName: { eq: "assets" } }) {
            nodes {
                name
                relativePath
                childImageSharp {
                    gatsbyImageData(layout: CONSTRAINED, width: 1200)
                }
            }
        }
    }
`;
